import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { GiftTicketAutocompleteDto } from '@/repositories/generated';

const response: GiftTicketAutocompleteDto[] = [
  {
    id: 1,
    name: 'モック商品券面1',
  },
  {
    id: 2,
    name: 'モック商品券面2',
  },
  {
    id: 3,
    name: 'モック商品券面3',
  },
];

export const autocompleteGiftTicket = http.get(
  createMockEndpoint('/autocomplete/gift_ticket'),
  async () => {
    await delay(500);
    return HttpResponse.json(response, { status: 200 });
  },
);
